import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import { useResponsive } from "../../hooks/use-responsive";

export default function HeroFour() {

  const mdUp = useResponsive("up", "md");

  return (

    <Grid
      container
      spacing={3}
      sx={{ justifyContent: "center", alignContent: "center" }}
    >
      {mdUp && (
        <Grid item xs={12} md={6}>
          <Typography
            component="span"
            className="HeroHeading2"
          >
            ARE YOU WORRIED ABOUT YOUR &nbsp;<span className="HeroHighlighted2"  >CHILD'S ONLINE SAFETY?</span>
          </Typography>

          <Box justifyContent='center' alignItems='center' mt='28px' >
            <Typography className="heroText" >
              Protect your child with MegaConnect's trusted solution for a safer online experience. Start safeguarding their digital journey today!
            </Typography>
          </Box>

        </Grid>
      )}
      {mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_four.svg"
            alt="home_hero_four"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/home_hero_four_sm.svg"
            alt="home_hero_four"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && (
        <Grid item xs={12} md={7} textAlign="center" >
          <Typography
            component="span"
            className="HeroHeading"
            textAlign={'center'}
          >
            ARE YOU WORRIED ABOUT YOUR &nbsp;<span className="HeroHighlighted"  >CHILD'S ONLINE SAFETY?</span>
          </Typography>

          <Box sx={{
            // mt: '18px',
            minHeight: '106px', // Set a minimum height for the Box
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}   >
            <Typography textAlign='center' className="heroText"
            >
              Protect your child with MegaConnect's trusted solution for a safer online experience. Start safeguarding their digital journey today!
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
